import React, { useEffect, useRef } from 'react';
import shaka from 'shaka-player';

export const VideoRenderDash = ({ step, ...props}) => {
    const mediaToken = localStorage.getItem('mediatoken');
    const videoRef = useRef(null);

    useEffect(() => {
        shaka.polyfill.installAll();
        if (shaka.Player.isBrowserSupported()) {
            initPlayer();
                } else {
                console.error('Browser not supported!');
            }

        return () => {
            if (videoRef.current) {
                videoRef.current.src = null;
            }
        };
    }, [step.content]);

    const initPlayer = () => {
        const player = new shaka.Player(videoRef.current);

        player.getNetworkingEngine().registerRequestFilter((type, request) => {
            if (type === shaka.net.NetworkingEngine.RequestType.SEGMENT) {
                request.uris[0] += (request.uris[0].includes('?') ? '&' : '?') + `${mediaToken}`;
            }
        });

        player.addEventListener('error', onErrorEvent);
        
        player.load(`${step.content}?${mediaToken}`).catch(onError);
    };

    const onErrorEvent = (event) => {
        onError(event.detail);
    };

    const onError = (error) => {
        console.error('Error code', error.code, 'object', error);
    };

    return (
        <div style={{ maxWidth: '100%', maxHeight: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <video ref={videoRef} 
                width='80%'
                height='80%' 
                controls 
            />
        </div>
    );
};
